import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Button, Container, Grid } from '@mui/material';
import axios from 'axios';
import { API_URL } from '../../Config';
import swal from 'sweetalert';

export default function BasicTextFields() {

        const handleSubmit=async (e)=>{
        e.preventDefault();
        const firstname = e.target.firstname.value;
        const lastname = e.target.lastname.value;
        const email= e.target.Email.value;
        const Phone = e.target.Phone.value;
        const Message =e.target.Message.value;

        if(firstname!="" && lastname!="" && email!="" && Phone!="" && Message!=""){

            var data =new FormData();
            data.append("firstname",firstname);
            data.append("lastname",lastname);
            data.append("Email",email);
            data.append("Phone",Phone);
            data.append("Message",Message);

            await axios.post(`${API_URL}/contactus.php`,data,{
                headers:{
                    "Content-Type":"multipart/form-data",
                }
            }).then((result )=>{
                console.log(result);
                if(result.data.code == 200){

                    swal({ 
                        title: "Success", 
                        text: result.data.message,
                        icon: "success" ,
                        allowOutsideClick: false,
                        confirmButtonText: 'ok',
                        confirmButtonColor: '#2dbe60',})

                }else if(result.data.code == 500){

                    swal({ 
                        title: "Warning", 
                        text: result.data.message,
                        icon: "error" ,
                        allowOutsideClick: false,
                        confirmButtonText: 'ok',
                        confirmButtonColor: '#2dbe60',})
                    }
            })
        }else{
            swal({ 
                title: "Warning", 
                text: "Please fill all the details",
                icon: "error" ,
                allowOutsideClick: false,
                confirmButtonText: 'ok',
                confirmButtonColor: '#2dbe60',})
        }
    }

    return (
        <Box className='contact_us' paddingY={4}>
            <Container maxWidth='lg'>
            <Box className='' variant='h1' paddingY={2} fontWeight='bold' textAlign='center' fontSize='45px'>
                    Contact Us
                  </Box>
                <Grid container spacing={2} className='contracts'>
                    <Grid item lg={6} sm={6} md={6} xs={11}>

                        <Box component="form" enctype='multipart/form-data' onSubmit={handleSubmit}  sx={{ '& > :not(style)': { m: 1, }, }}
                            noValidate autoComplete="off" >
                            <TextField id="outlined-basic" fullWidth label="First Name" name="firstname" variant="outlined" />
                            <TextField id="outlined-basic" fullWidth label="Last Name" name="lastname" variant="outlined" />
                            <TextField id="outlined-basic" fullWidth label="Email" name="Email"  type="email" variant="outlined" />
                            <TextField id="outlined-basic" fullWidth label="Phone" name="Phone" variant="outlined"  type="number"/>
                            <TextField id="outlined-basic" fullWidth label="Message" name="Message" variant="outlined" />
                            <Button variant='contained' type="submit" >Submit</Button>
                        </Box>
                    
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={12} textAlign='center' >
                        <img src='./img/contact-us01.png' width='80%'  />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}
